import { Link } from 'react-router-dom';
import './PlaceholderPage.css';

// 404 page — caught by react-router-dom's catch-all route.
export default function NotFound() {
  return (
    <div className="container placeholder-page">
      <span className="eyebrow fade-in-1">404 · Not Found</span>
      <h1 className="placeholder-title fade-in-2">
        We couldn't find that <em>page</em>.
      </h1>
      <div className="placeholder-body fade-in-3">
        <p>
          The page you're looking for doesn't exist — or doesn't exist yet.
          Brain Health by Quiltt is in active development.
        </p>
        <p>
          <Link to="/" className="btn">
            Back to home
          </Link>
        </p>
      </div>
    </div>
  );
}
